var play_icon_rtlignore_default = {
  "shadow": "SAweD",
  "playIcon": "OuhBB"
};
export {
  play_icon_rtlignore_default as default
};
//# sourceMappingURL=play-icon.rtlignore-scss.js.map
